module.exports = __webpack_public_path__ + "img/tongli.d1f77600.jpg";